import {createI18n} from 'vue-i18n'
import {Locale} from '@/composables/locale'
import ru from '@/locales/ru.json'
import kk from '@/locales/kk.json'
import {watch} from 'vue'
import {localeStorage} from '@/helpers/storage'

const i18n = createI18n({
  legacy: false,
  locale: localeStorage.get() || Locale.Ru,
  fallbackLocale: Locale.Ru,
  messages: {ru, kk},
})

watch(i18n.global.locale, locale => localeStorage.set(locale))

export default i18n
